import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { checkLogin } from '../../api/POST_checkLogin';
import { postStart } from '../../api/POST_start';
import ModalConfirmation from '../../components/ModalConfirmation';
import ModalLoading from '../../components/ModalLoading';
import {
	CheckLogin,
	OutletCrew,
	Start,
} from '../../pages/outlet-crew/Home.type';
import {
	_removeLocalStorageItem,
	_retrieveLocalStorageItem,
	_storeLocalStorageItem,
} from '../../utils/localStorage';

const Home = () => {
	const [isModalConfirmationVisible, setIsModalConfirmationVisible] =
		React.useState(false);
	const [isModalLoadingVisible, setIsModalLoadingVisible] =
		React.useState(true);
	const [isAuthenticated, setIsAuthenticated] = React.useState(false);
	const [data, setData] = React.useState<Array<OutletCrew>>([]);
	const [errorMessage, setErrorMessage] = React.useState('');
	const history = useHistory();
	const location = useLocation();

	const cancelButtonRef = React.useRef(null);

	const onCheckLogin = React.useCallback(() => {
		const code = new URLSearchParams(location.search).get('code');
		const state = new URLSearchParams(location.search).get('state');
		const existingProducts = _retrieveLocalStorageItem('products');
		const currentTime = new Date();

		if (existingProducts) {
			const existingProductParse = JSON.parse(existingProducts);
			const existingTime = new Date(existingProductParse.time);
			if (existingTime.getDate() < currentTime.getDate()) {
				_removeLocalStorageItem('products');
			}
		}

		const body: CheckLogin = {
			code,
			state: parseInt(state),
		};

		checkLogin(body).then(
			({ accessToken, data, status, messageDescription }) => {
				if (status === 'success') {
					setIsAuthenticated(true);
					setIsModalLoadingVisible(false);
					setIsModalConfirmationVisible(true);
					setData(data);
					_storeLocalStorageItem({
						storageKey: 'accessToken',
						storageValue: accessToken,
					});
				} else {
					setErrorMessage(messageDescription);
					setIsModalLoadingVisible(false);
					setIsModalConfirmationVisible(true);
				}
			},
		);
	}, [location.search]);

	React.useEffect(() => {
		onCheckLogin();
		() => {
			setIsModalConfirmationVisible(false);
		};
	}, [onCheckLogin]);

	const onClick = async () => {
		const currentDate = new Date();
		const hour = currentDate.getHours();
		const minute = currentDate.getMinutes();
		const second = currentDate.getSeconds();
		const currentTime = `${hour < 10 ? '0' + hour : hour}:${
			minute < 10 ? '0' + minute : minute
		}:${second < 10 ? '0' + second : second}`;
		const body: Start = {
			scheduleName: data[0].scheduleName,
			time: currentTime,
			outletCrewId: data[0].crewId,
		};
		try {
			const { status } = await postStart(body);
			if (status === 'success') {
				history.push({
					pathname: '/outlet-crew-form',
					state: { data },
				});
			}
		} catch (error) {
			return error;
		}
	};

	const closeModalBackground = () => undefined;
	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			<ModalLoading
				icon="/images/spinnerGreen.gif"
				description="Mohon tunggu sebentar, kami sedang memproses permintaan kamu"
				onClick={onClick}
				cancelButtonRef={cancelButtonRef}
				isShowModal={isModalLoadingVisible}
				closeModalBackground={closeModalBackground}
			/>
			<ModalConfirmation
				icon="/images/warning.svg"
				title={
					isAuthenticated ? 'Mulai Perhitungan Stok?' : 'Akses Tidak Tersedia!'
				}
				description={
					isAuthenticated
						? 'Apakah kamu yakin untuk memulai perhitungan stok produk?'
						: errorMessage
				}
				onClick={onClick}
				cancelButtonRef={cancelButtonRef}
				isShowModal={isModalConfirmationVisible}
				closeModalBackground={closeModalBackground}
				variantButton={isAuthenticated ? 'SINGLE' : 'NONE'}
				textCenter="Mulai"
			/>
		</div>
	);
};

export default Home;
